module.exports = __webpack_public_path__ + "bd2684db87558d933d1d9682fab21ef7.MP3";